var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('download-popup', {
    attrs: {
      "data-to-show": _vm.isDownloadPopupDisplayed
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateDownloadPopup(false);
      },
      "downloadPDF": _vm.downloadPDF
    }
  }), _vm._v(" "), _vm.currentStep === 'shaping' ? _c('mise-en-forme', {
    staticClass: "px-10"
  }) : _vm._e(), _vm._v(" "), _vm.currentStep === 'title' ? _c('titre-et-accroche', {
    staticClass: "px-10"
  }) : _vm._e(), _vm._v(" "), _vm.currentStep === 'personnal' ? _c('informations-personnelles', {
    staticClass: "px-10"
  }) : _vm._e(), _vm._v(" "), _vm.currentStep === 'formations' ? _c('formations') : _vm._e(), _vm._v(" "), _vm.currentStep === 'pro' ? _c('experiences-professionnelles') : _vm._e(), _vm._v(" "), _vm.currentStep === 'comp' ? _c('competences') : _vm._e(), _vm._v(" "), _vm.currentStep === 'langues' ? _c('langues') : _vm._e(), _vm._v(" "), _vm.currentStep === 'hobbies' ? _c('centres-interets') : _vm._e(), _vm._v(" "), _vm.currentStep === 'success' ? _c('cles-reussite') : _vm._e(), _vm._v(" "), _vm.currentStep === 'needs' ? _c('besoin-travail') : _vm._e(), _vm._v(" "), _vm.currentStep === 'atouts' ? _c('atouts') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center md:justify-end space-x-5 mt-10 mx-10"
  }, [_vm.positionCvPage > 0 ? _c('action-button', {
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-100",
      "bg-color-square": "bg-pink-100",
      "libelle": "Précédent",
      "uppercase": true
    },
    on: {
      "clickAction": function ($event) {
        return _vm.SET_CURRENTSTEP(_vm.cvPages[_vm.positionCvPage - 1].name);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('action-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.positionCvPage < _vm.cvPages.length - 1,
      expression: "positionCvPage < cvPages.length-1"
    }],
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "libelle": "Suivant",
      "type-shadow": "shadow-pink",
      "uppercase": true
    },
    on: {
      "clickAction": function ($event) {
        return _vm.SET_CURRENTSTEP(_vm.cvPages[_vm.positionCvPage + 1].name);
      }
    }
  }), _vm._v(" "), _c('action-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.positionCvPage === _vm.cvPages.length - 1,
      expression: "positionCvPage === cvPages.length-1"
    }],
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "libelle": "Suivant",
      "type-shadow": "shadow-pink",
      "uppercase": true
    },
    on: {
      "clickAction": function ($event) {
        return _vm.changeStateDownloadPopup(true);
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }